import React from 'react';
import { hashClass } from '../../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../../context';
const a11y = { role: 'scrolling-menu' };
/**
 * Menu Component
 *  @param className {string} Additionnal CSS Classes
 *  @param children {number} ReactNode} Dropdown Children
 *  @param pulled {string} left|right
 *  @param hasBackgroundWhite {boolean} If have white background
 */
const MenuScrolling = ({ className, hasBackgroundWhite, pulled, ...others }) => {
    /**
     * If no markup return p with default level 1
     */
    const { styled } = useTrilogyContext();
    const classes = ['menu', `is-pulled-${pulled !== null && pulled !== void 0 ? pulled : 'left'}`, className];
    if (hasBackgroundWhite) {
        classes.push('has-background-white');
    }
    return React.createElement("aside", { className: hashClass(styled, clsx(classes)), ...a11y, ...others });
};
export default MenuScrolling;
//# sourceMappingURL=MenuScrolling.js.map